/**
 * @generated SignedSource<<eb37ddb637bc490f92956c9326bf5f69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserPage_user$data = {
  readonly displayName: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UserDetails_user">;
  readonly " $fragmentType": "UserPage_user";
};
export type UserPage_user$key = {
  readonly " $data"?: UserPage_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserPage_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserPage_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "507b2a63ac1f065ad57ff86170a33ed9";

export default node;
